// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"5eb25c7f","48":"f78044e0","85":"0d7bed5d","149":"222c667b","150":"6ce6b966","208":"9831baca","299":"69256fb1","302":"88b0e871","473":"facaf59f","474":"35b83a71","581":"9dcbc89c","725":"3e7c09d5","852":"8ab82073","944":"87b57918"}[chunkId] + ".chunk.js";
};